import type { SiteConfigFn } from '@wix/thunderbolt-vsm-api-types'
import type { OoiTpaSharedConfigSiteConfig } from '../types'
import { fontsCssFileUrl, wixMadeforFontsUrl, helveticaCssUrl, googleFonts as googleFontsUrl } from '@wix/fonts-data'
import { TPA_COMPONENTS } from '@wix/thunderbolt-commons'

const ooiTpaSharedConfigSiteConfig: SiteConfigFn<OoiTpaSharedConfigSiteConfig> = ({ api }) => {
	const componentsCountHints = api.rendererModel.getSiteMetaData()?.renderHints?.componentsCount ?? {}
	const hasTPA = Object.keys(componentsCountHints).some(
		(compType) => TPA_COMPONENTS[compType as keyof typeof TPA_COMPONENTS]
	)
	const hasPlatform = api.features.isActive('platform')
	const hasTpaWorker = api.features.isActive('tpaWorkerFeature')

	const shouldLoadSiteConfig = hasTPA || hasPlatform || hasTpaWorker

	if (!shouldLoadSiteConfig) {
		return {
			shouldLoadSiteFeature: false,
			shouldLoadSiteConfig: false,
			siteConfig: null,
		}
	}

	// Build imageSpriteUrl
	const serviceTopology = api.rootConfig.getServiceTopology()
	const scriptsDomainUrl = serviceTopology?.scriptsDomainUrl || 'https://static.parastorage.com/'

	const getMediaUrl = (relativePath: string, mediaFile: string, destinationFolder = 'resources') => {
		const baseUrl = scriptsDomainUrl.substring(0, scriptsDomainUrl.length - 1)
		const protocol = baseUrl.startsWith('https:') ? 'https:' : baseUrl.startsWith('http:') ? 'http:' : ''

		const isPreviewMode = api.rendererModel.getPreviewMode()
		const adjustedBaseUrl = isPreviewMode ? baseUrl.substring(protocol.length, baseUrl.length) : baseUrl

		return [adjustedBaseUrl, 'services', 'santa-resources', destinationFolder, 'viewer', relativePath, mediaFile].join(
			'/'
		)
	}

	const imageSpriteUrl = getMediaUrl('editorUI', 'fonts.v19.png')

	// Build wixStaticFontsLinks
	const isWixSite = api.rendererModel.getSiteInfo()?.documentType === 'WixSite'
	const wixStaticFontsLinks = [
		fontsCssFileUrl,
		wixMadeforFontsUrl,
		googleFontsUrl,
		isWixSite ? helveticaCssUrl : '',
	].filter((link) => link !== '')

	const siteConfig: OoiTpaSharedConfigSiteConfig = {
		imageSpriteUrl,
		wixStaticFontsLinks,
	}

	return {
		shouldLoadSiteFeature: false,
		shouldLoadSiteConfig: true,
		siteConfig,
	}
}

const name = 'ooiTpaSharedConfig'

export const config = { site: ooiTpaSharedConfigSiteConfig, name }
